import { useSelector }      from "react-redux";
import ReservationHistories from "../../../../domain/reservation/history/ReservationHistories";
import { ResKaState }       from "../../../../index";
import ResKaReduxAction     from "../../ResKaReduxAction";

enum ReservationHistoriesActionType {
  INIT_RESERVATION_HISTORIES = "INIT_RESERVATION_HISTORIES",
  SET_RESERVATION_HISTORIES = "SET_RESERVATION_HISTORIES",
}

interface InitReservationHistoriesAction extends ResKaReduxAction {
}

interface SetReservationHistoriesAction extends ResKaReduxAction {
  histories: ReservationHistories;
}

type ReservationHistoriesAction = InitReservationHistoriesAction | SetReservationHistoriesAction;

export const initReservationHistoriesAction = (): InitReservationHistoriesAction => ({
  type: ReservationHistoriesActionType.INIT_RESERVATION_HISTORIES,
});

export const setReservationHistoriesAction = (histories: ReservationHistories): SetReservationHistoriesAction => ({
  type: ReservationHistoriesActionType.SET_RESERVATION_HISTORIES,
  histories: histories,
});

export const reservationHistoriesReducer = (state: ReservationHistories = new ReservationHistories(), action: ReservationHistoriesAction): ReservationHistories => {
  switch (action.type) {
    default:
      return state;
    case ReservationHistoriesActionType.INIT_RESERVATION_HISTORIES:
      return new ReservationHistories();
    case ReservationHistoriesActionType.SET_RESERVATION_HISTORIES:
      return (action as SetReservationHistoriesAction).histories;
  }
};

export const useReservationHistories = (): ReservationHistories => useSelector((state: ResKaState) => state.reservationHistories);
